// eslint-disable-next-line import/no-cycle

export const formatIsoDate = (date: string): string => {
  if (!date) return date;
  const newDate = new Date(date);
  const day = newDate.getDate();
  const month = newDate.getMonth() + 1;
  const year = newDate.getFullYear();
  return `${day}/${month}/${year}`;
};

export const formatDateTime = (dateTimeStr: string) => {
  if (typeof dateTimeStr !== 'string' || dateTimeStr === '') {
    return '';
  }

  const date = new Date(dateTimeStr);

  const formattedDate = `${`0${date.getDate()}`.slice(-2)}/${`0${date.getMonth() + 1}`.slice(-2)}/${date.getFullYear()}`;

  const formattedTime = `${`0${date.getHours()}`.slice(-2)}:${`0${date.getMinutes()}`.slice(-2)}`;

  return `${formattedDate} ${formattedTime}`;
};
